import { Route, Routes } from 'react-router-dom';
import './App.css';
import Extra from './Components/Extra';
import Home from './Components/Home';
import About from './Components/About';
import Product from './Components/Product';
import Video from './Components/Video';
import Contactus from './Components/Contactus';

function App() {
  return (
    <div className="App">

      <Routes>
        <Route path='/' element={<Home></Home>}/>
        <Route path='/about' element={<About></About>}/>
        <Route path='/product' element={<Product></Product>}/>
        <Route path='/new' element={<Extra></Extra>}/>
        <Route path='/video' element={<Video></Video>}/>
        <Route path='/contactus' element={<Contactus></Contactus>}/>
      </Routes>
    </div>
  );
}

export default App;

